const el = document.querySelector('.vp-block-home-realisations')

let list, items, first, last, current, next, prev
const positions = []

if (el) {
    list = el.querySelector('.list')
    items = list.querySelectorAll(':scope > *')
    if (items.length) {
        first = 0
        last = items.length - 1
        current = 0
        for (const [i, item] of items.entries()) {
            positions[i] = item.offsetLeft * -1
            item.addEventListener('click', (e) => {
                if (current !== i) {
                    e.preventDefault()
                    current = i
                    update()
                }
            })
        }
        next = el.querySelector('.controls .next')
        prev = el.querySelector('.controls .prev')
        next.addEventListener('click', () => {
            if (current < last) current++
            update()
        })
        prev.addEventListener('click', () => {
            if (current > first) current--
            update()
        })
        update()
    }
}

function update() {
    prev.classList.toggle('disabled', current <= first)
    next.classList.toggle('disabled', current >= last)
    list.querySelector('.current')?.classList.remove('current')
    const item = items[current] || null
    if (item) {
        item.classList.add('current')
        list.style.transform = `translateX(${positions[current]}px)`
    }
}
